import { render } from "./ContentReportModalComponent.vue?vue&type=template&id=37c0b5d4&scoped=true"
import script from "./ContentReportModalComponent.vue?vue&type=script&lang=js"
export * from "./ContentReportModalComponent.vue?vue&type=script&lang=js"

import "./ContentReportModalComponent.vue?vue&type=style&index=0&id=37c0b5d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c0b5d4"]])

export default __exports__